module.exports = "<div class=\"container-fluid\">\n  <div class=\"row-fluid\">\n    <div class=\"row\">\n      <div class=\"col-sm-3\" style=\"margin-left:3%\"></div>\n      <div class=\"col-sm-4 main-column\" style=\"background-color:lavender;\">\n        <p class=\"lead\">Login</p>\n        <app-login></app-login>\n      </div>\n      <div class=\"col-sm-3\"></div>\n    </div>\n  </div>\n</div>\n\n\n\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login-page/login-page.component.html
// module id = ./src/app/login-page/login-page.component.html
// module chunks = main